import { render, staticRenderFns } from "./modal-wholesale-terms.vue?vue&type=template&id=8457ec46"
import script from "./modal-wholesale-terms.vue?vue&type=script&lang=js"
export * from "./modal-wholesale-terms.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports